export default __webpack_public_path__ + "static/media/GU.3facd54e.svg";